import utils from 'helpers/utils';
import {useServiceApiMutation, useServiceApiQuery} from 'stores/hooks/query';

const path = utils.servicePath(import.meta.url);

export function useClientTimelineList ({clientId, page, pageSize, ...rest}, queryOptions = {}) {
  return useServiceApiQuery(path, 'list', {clientId, page, pageSize, ...rest}, queryOptions);
}

export function useTimelineMarkAllRead ( mutationOptions = {}) {
  return useServiceApiMutation(path, 'post', {}, {
    refetchContext: true,
    overridePath: 'clients/:clientId/timeline/read', ...mutationOptions
  });
}

export function useTimelineMarkAllUnread ( mutationOptions = {}) {
  return useServiceApiMutation(path, 'delete', {}, {
    refetchContext: true,
    overridePath: 'clients/:clientId/timeline/read', ...mutationOptions
  });
}
